"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoUtils = void 0;
var CryptoJS = __importStar(require("crypto-js"));
var CryptoUtils = /** @class */ (function () {
    function CryptoUtils() {
    }
    CryptoUtils.randomBytes = function (length) {
        return CryptoJS.lib.WordArray.random(length);
    };
    CryptoUtils.toBase64 = function (buffer) {
        return CryptoJS.enc.Base64.stringify(buffer);
    };
    CryptoUtils.toHex = function (buffer) {
        return CryptoJS.enc.Hex.stringify(buffer);
    };
    CryptoUtils.fromBase64 = function (base64) {
        return CryptoJS.enc.Base64.parse(base64);
    };
    CryptoUtils.toString = function (buffer) {
        return CryptoJS.enc.Utf8.stringify(buffer);
    };
    CryptoUtils.encrypt = function (salt, key, plaintext) {
        return CryptoJS.AES.encrypt(plaintext, key, { iv: salt }).ciphertext.toString(CryptoJS.enc.Base64);
    };
    CryptoUtils.decrypt = function (salt, key, base64Ciphertext) {
        return CryptoJS.AES.decrypt(base64Ciphertext, key, { iv: salt });
    };
    return CryptoUtils;
}());
exports.CryptoUtils = CryptoUtils;
